(function () {

  // ─── SHARED: enforce multiple on any input with data-qty-step ───
  function enforceMultiple(input) {
    var step = parseInt(input.getAttribute('data-qty-step')) || 1;
    var min  = parseInt(input.getAttribute('data-min'))      || step;
    if (step <= 1) return;
    var value = parseInt(input.value) || min;
    if (value < min) value = min;
    var remainder = value % step;
    if (remainder !== 0) value = value - remainder + step;
    input.value = value;
  }

  function initQuantityControls(scope) {
    var container = scope || document;
    container.querySelectorAll('quantity-input').forEach(function (qtyInput) {
      var input = qtyInput.querySelector('.quantity__input');
      if (!input) return;
      var step = parseInt(input.getAttribute('data-qty-step')) || 1;
      if (step <= 1) return;
      var min = parseInt(input.getAttribute('data-min')) || step;

      if (!input.value || parseInt(input.value) < min) input.value = min;

      if (input.dataset.pcBound) return;
      input.dataset.pcBound = '1';

      var minusBtn = qtyInput.querySelector('[name="minus"]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var current = parseInt(input.value) || min;
          var newVal  = current - step;
          input.value = newVal < min ? min : newVal;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      var plusBtn = qtyInput.querySelector('[name="plus"]');
      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var current = parseInt(input.value) || min;
          var max     = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : null;
          var newVal  = current + step;
          if (max && newVal > max) newVal = current;
          input.value = newVal;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      input.addEventListener('change', function () { enforceMultiple(input); });
      input.addEventListener('blur',   function () { enforceMultiple(input); });
    });
  }

  // ─── PART 2: collection minimum warnings in cart ───
  function checkCollectionMins(containerSelector, warningContainerId) {
    var container        = document.querySelector(containerSelector);
    var warningContainer = document.getElementById(warningContainerId);
    if (!container || !warningContainer) return;

    var collections = {};
    container.querySelectorAll('tr[data-collection-tag]').forEach(function (row) {
      var tag = row.getAttribute('data-collection-tag');
      var min = parseInt(row.getAttribute('data-collection-min')) || 0;
      var qtyInput = row.querySelector('.quantity__input');
      var qty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;
      if (!collections[tag]) collections[tag] = { total: 0, min: min, label: tag.replace('collection-', '') };
      collections[tag].total += qty;
      if (min > collections[tag].min) collections[tag].min = min;
    });

    warningContainer.innerHTML = '';
    Object.keys(collections).forEach(function (tag) {
      var col = collections[tag];
      if (col.min > 0 && col.total < col.min) {
        var missing = col.min - col.total;
        var div = document.createElement('div');
        div.className = 'collection-min-warning is-visible';
        div.setAttribute('role', 'alert');
        var name = col.label.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        div.innerHTML = '<strong>' + name + ':</strong> add ' + missing + ' more piece' + (missing > 1 ? 's' : '') + ' to reach the minimum of ' + col.min + ' pcs for this collection.';
        warningContainer.appendChild(div);
      }
    });
  }

  function initCollectionMinCheck() {
    checkCollectionMins('#CartDrawer-CartItems',  'collection-min-warnings-drawer');
    checkCollectionMins('#main-cart-items', 'collection-min-warnings-page');
  }

  // ─── INIT ───
  document.addEventListener('DOMContentLoaded', function () {
    initQuantityControls();
    initCollectionMinCheck();
    document.addEventListener('variant:changed', function () {
      setTimeout(initQuantityControls, 300);
    });
  });

  document.addEventListener('cart:updated', function () {
    setTimeout(function () { initQuantityControls(); initCollectionMinCheck(); }, 300);
  });

  document.addEventListener('cart:refresh', function () {
    setTimeout(function () { initQuantityControls(); initCollectionMinCheck(); }, 300);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('quantity__input')) {
      setTimeout(initCollectionMinCheck, 400);
    }
  });

})();
